import { render, staticRenderFns } from "./UsuariosFormulario.vue?vue&type=template&id=3a3137a2&"
import script from "./UsuariosFormulario.vue?vue&type=script&lang=ts&"
export * from "./UsuariosFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports